<div class="card info-card c:white m-32:t">
    @if (shouldChangeTheftCoverage() || shouldChangeDeductible()) {
        <p class="fw:bold">Empfohlene Alternative</p>
        <p>
            Wir empfehlen dir,
            @if (shouldChangeDeductible()) {
                @if (hasDeductible()) {
                    die Selbstbeteiligung zu entfernen
                } @else {
                    eine Selbstbeteiligung zu ergänzen
                }
            } @else {
                @if (hasDeductible()) {
                    die Selbstbeteiligung beizubehalten
                } @else {
                    den Tarif ohne Selbstbeteiligung beizubehalten
                }
            }
            und
            @if (shouldChangeTheftCoverage()) {
                @if (hasTheftCoverage()) {
                    den Diebstahlschutz zu entfernen.
                } @else {
                    den Diebstahlschutz zu ergänzen.
                }
            } @else {
                @if (hasTheftCoverage()) {
                    den Diebstahlschutz beizubehalten.
                } @else {
                    den Tarif ohne Diebstahlschutz beizubehalten.
                }
            }
        </p>
        @if (recommendedPrice()) {
            <p>
                Dein Beitrag ändert sich von {{ price() | splitCurrency }}&nbsp;€ auf
                {{ recommendedPrice() | splitCurrency }}&nbsp;€.
            </p>
        }
        <p>Deine Antworten zum versicherten Gerät bleiben unabhängig von deiner Entscheidung erhalten.</p>

        <div class="grid-container -two-buttons m-0">
            <button
                class="button -ghost c:white"
                (click)="applyAdvice.emit(false)"
            >
                Aktuelle Auswahl beibehalten
            </button>
            <button
                type="submit"
                class="-width-auto"
                (click)="applyAdvice.emit(true)"
            >
                Empfehlung übernehmen
            </button>
        </div>
    } @else if (wrongInsurance()) {
        <p class="fw:bold">Wähle einen anderen Tarif aus</p>
        <p>
            Der gewählte Tarif passt nicht zu deinen Bedürfnissen. Wähle stattdessen einen anderen Tarif, zum Beispiel
            die
            <a
                class="c:white underline"
                aria-label="Startseite Handyversicherung"
                routerLink="/produkte/handyversicherung"
            >
                Handyversicherung</a
            >
            oder die allgemeine
            <a
                class="c:white underline"
                aria-label="Startseite Elektronikversicherung"
                routerLink="/produkte/elektronikversicherung"
            >
                Elektronikversicherung</a
            >
            für deine Geräte.
        </p>

        <div class="grid-container -end m-0">
            <a
                aria-label="Zurück zur Startseite"
                class="button toggle-width"
                routerLink="/"
            >
                Zurück zur Startseite
            </a>
        </div>
    } @else {
        <p class="fw:bold">Deine Auswahl passt zu deinen Bedürfnissen</p>
        <p>Du hast bereits den passenden Tarif gewählt.</p>

        <div class="grid-container -end m-0">
            <button
                type="submit"
                class="toggle-width"
                (click)="applyAdvice.emit(false)"
            >
                Nächster Schritt
            </button>
        </div>
    }
</div>
